import Swiper, { Navigation, Pagination } from 'swiper';

export function initSwiper() {
  new Swiper('[data-swiper]', {
    modules: [],
  });
  new Swiper('[data-swiper="events"]', {
    modules: [Navigation],
    slidesPerView: 1,
    autoHeight: false,
    loop: false,
    speed: 200,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
  });

  new Swiper('.package-highlights', {
    modules: [Pagination],
    slidesPerView: 1.1,
    centeredSlides: true,
    centerInsufficientSlides: true,
    centeredSlidesBounds: true,
    initialSlide: 1,
    breakpoints: {
      400: {
        slidesPerView: 1.2,
      },
      640: {
        slidesPerView: 1.3,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  new Swiper('.speaker', {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  new Swiper('.testimonials', {
    modules: [Pagination],
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}
